export const EMAIL_UPDATE = 'EMAIL_UPDATE';
export const EMAIL_UPDATE_DONE = 'EMAIL_UPDATE_DONE';
export const EMAIL_UPDATE_ERR = 'EMAIL_UPDATE_ERR';
export const CONFIRM_EMAIL_CHANGE = 'CONFIRM_EMAIL_CHANGE';
export const CONFIRM_EMAIL_UPDATE_DONE = 'CONFIRM_EMAIL_UPDATE_DONE';
export const CONFIRM_EMAIL_UPDATE_ERR = 'CONFIRM_EMAIL_UPDATE_ERR';
export const EMAIL_UPDATE_RESET = 'EMAIL_UPDATE_RESET';
//# sourceMappingURL=actionTypes.js.map